import { Grid, Typography } from "@material-ui/core";
import React from "react";
import Sidebar from "views/sidebar/Sidebar";
import { Route } from "react-router-dom";
import "../App.css";

export default function Template({ routes }) {
  return (
    <div>
      <Grid container alignItems="flex-start" justifyContent="flex-start">
        <Grid
          item
          xs={12}
          md={3}
          lg={2}
          style={{
            background: "white",
            textAlign: "left",
          }}
        >
          <Sidebar />
        </Grid>
        <Grid item xs={12} md={9}>
          {routes.map((route) => {
            return (
              <Route
                path={route.path}
                exact={route.exact}
                component={route.component}
              />
            );
          })}
        </Grid>
      </Grid>
    </div>
  );
}
